import {
  RemixiconComponentType,
  RiAccountCircleLine,
  RiBriefcaseLine,
  RiFacebookCircleFill,
  RiStoreLine,
  RiTwitterXFill,
  RiWhatsappFill,
} from "@remixicon/react";
import { RiShareLine } from "react-icons/ri";
import { SelectOption } from "../constants/SelectOption";

export interface ProfileComplete {
  id: any;
  name: string;
  isComplete: boolean;
}

export interface MenuTabInterface {
  id: any;
  name: string;
  element: JSX.Element;
}

export interface ChangeEmailInterface {
  oldEmail: string | undefined;
  newEmail: string | undefined;
}

export interface PaginationInterface {
  currentPage: number;
  limit: number;
  total: number;
  nextPage: number;
  previousPage: number;
}

export const paginationOptions = [
  { id: 1, name: 10 },
  { id: 2, name: 20 },
  { id: 3, name: 50 },
  { id: 4, name: 100 },
];

export interface TypeLoginInterface {
  id: any;
  icon: RemixiconComponentType;
  title: string;
  link: string;
}

export const typeLogin: TypeLoginInterface[] = [
  {
    id: 0,
    icon: RiAccountCircleLine,
    title: "Pembeli",
    link: "/login",
  },
  {
    id: 1,
    icon: RiBriefcaseLine,
    title: "Reseller",
    link: "/login?type=reseller",
  },
  {
    id: 2,
    icon: RiStoreLine,
    title: "Supplier",
    link: "/login?type=supplier",
  },
];

export const socMeds = [
  {
    id: 1,
    name: "Whatsapp",
    icon: RiWhatsappFill,
    color: "green.400",
    shareUrl: `https://wa.me/?text=${encodeURIComponent(window.location.href)}`,
  },
  {
    id: 2,
    name: "Facebook",
    icon: RiFacebookCircleFill,
    color: "blue.600",
    shareUrl: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      window.location.href
    )}`,
  },
  {
    id: 3,
    name: "X/Twitter",
    icon: RiTwitterXFill,
    color: "black",
    shareUrl: `https://twitter.com/intent/tweet?url=${encodeURIComponent(
      window.location.href
    )}&text=${encodeURIComponent("Check this out!")}`,
  },
  {
    id: 4,
    name: "Salin Link",
    icon: RiShareLine,
    color: "blue.500",
    shareUrl: ``,
  },
];

export const paymentMethod: SelectOption[] = [
  {
    id: 1,
    name: "Transfer Manual",
  },
];

export interface NavItem {
  label: string;
  subLabel?: string;
  children?: Array<NavItem>;
  href?: string;
}

export const NAV_ITEMS: Array<NavItem> = [
  {
    label: "Beranda",
    href: "/",
  },
  {
    label: "Produk",
    href: "/product",
  },
  {
    label: "Blog",
    href: "/blog",
  },
];

export const menuNav = [
  {
    label: "Blog",
    href: "/blog",
  },
  {
    label: "Produk",
    href: "/product",
  },
  {
    label: "Beranda",
    href: "/",
  },
];
